module.exports = __webpack_public_path__ + "static/media/pic1@2x.47debfe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic1@2x.png
// module id = 1394
// module chunks = 0